var map = {
	"./audience-hover.svg": 76026,
	"./audience.svg": 71507,
	"./automation-hover.svg": 11169,
	"./automation.svg": 37484,
	"./campaign-hover.svg": 84054,
	"./campaign.svg": 53407,
	"./dashboard-hover.svg": 84774,
	"./dashboard.svg": 83663,
	"./email-marketing.svg": 24860,
	"./gallery-hover.svg": 69216,
	"./gallery.svg": 92261,
	"./platform-hover-icon.svg": 77533,
	"./platform-icon.svg": 54726,
	"./reports-hover.svg": 68927,
	"./reports.svg": 41230,
	"./transational-hover.svg": 16290,
	"./transational.svg": 92715
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4189;